import axios from "axios";
import { APIHost } from "./helpers";

// Base URL
export const baseURL = () => {
  return APIHost() + ":3334/consumer/menu";
};

export const loadRestaurantMenuList = (id, type, all, params) => {
  const url = `${baseURL()}/load/${id}${
    type !== null ? (all !== null ? "/" + type + "/" + all : "/" + type) : ""
  }`;

  return axios.post(url, params);
};

export const loadRestaurantMenuCategory = (id, type) => {
  const url = `${baseURL()}/category/${id}/${type}`;

  return axios.get(url, {});
};

export const loadRestaurantMenuCategoryItems = (id, type, params) => {
  const url = `${baseURL()}/loadbycategory/${id}/${type}`;

  return axios.post(url, params);
};

export const loadRestaurantMenuDetail = (id) => {
  const url = `${baseURL()}/detail/${id}`;

  return axios.get(url);
};
